import { render, staticRenderFns } from "./IconDot.vue?vue&type=template&id=2ebfa608&"
import script from "./IconDot.vue?vue&type=script&lang=ts&"
export * from "./IconDot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports